import { Middleware } from 'redux';
import { isActionOfType } from 'store/utils';
import { AUTHENTICATE_RESET_ACCESS_TOKEN, AUTHENTICATE_LOGOUT } from 'store/authentication/actions';
import analyticsService from 'services/AnalyticsService';

/**
 * When a logout action or reset auth occurs, clear the current analytics service
 */
export const analyticsMiddleware: Middleware = () => next => action => {
  if (isActionOfType([AUTHENTICATE_LOGOUT, AUTHENTICATE_RESET_ACCESS_TOKEN], action)) {
    analyticsService.clear();
  }

  return next(action);
};
